import { service } from '@ember/service';
import Component from '@glimmer/component';

import Alert from 'umg-ember-backend/components/ui/alert';

import Default from './default';
import ExternalMediaEmbed from './external-media-embed';
import Rollback from './rollback';

export default class ApplicationConfirm extends Component {
  // Services
  @service confirm;

  // Getter and setter
  get ConfirmComponent() {
    const componentName = this.confirm.options?.componentName ?? 'default';
    const confirmComponents = {
      'default': Default,
      'external-media-embed': ExternalMediaEmbed,
      'rollback': Rollback,
    };

    return confirmComponents[componentName];
  }

  // Template
  <template>
    <Alert @isOpen={{this.confirm.showPrompt}} @onClose={{this.confirm.cancel}}>
      <this.ConfirmComponent @confirm={{this.confirm}} />
    </Alert>
  </template>
}
